import { IGetAllResponse, IGetOneResponse } from "../Utilis/Types/Generic";
import { Strategy } from "../Utilis/Types/Strategies";
import { ApiService } from "./ApiService";

export class StrategyService extends ApiService {
    static pathName = 'strategy';

    static getStrategies(): Promise<IGetAllResponse<Strategy>> {
        return this.get(`strategy`)
    }

    static getSingleStrategy(strategyId: number): Promise<IGetOneResponse<Strategy>> {
        return this.get(`strategy/${strategyId}`)
    }
}